module.exports = __webpack_public_path__ + "img/p4.d7e45837.png";